import { ATTACHMENT_ADD_ATTACHMENTS, ATTACHMENT_CLEAR_ALL_ATTACHMENT_SELECTIONS, ATTACHMENT_DELETE_ATTACHMENTS_SUCCESS, ATTACHMENT_GET_FILTERED_ATTACHMENTS_SUCCESS, ATTACHMENT_RESET_ATTACHMENTS, ATTACHMENT_SELECT_ATTACHMENT, ATTACHMENT_UPDATE_ATTACHMENTS } from '../actions';
import { createAttachmentState } from '../services';
import { addAttachmentIdsReducer } from './addAttachmentIdsReducer';
import { addAttachmentsReducer } from './addAttachmentsReducer';
import { deleteAttachmentIdsReducer } from './deleteAttachmentIdsReducer';
import { deleteAttachmentsReducer } from './deleteAttachmentsReducer';
import { updateAttachmentsReducer } from './updateAttachmentsReducer';
import { selectAttachmentReducer } from './selectAttachmentReducer';
import { deleteAttachmentPairsReducer } from './deleteAttachmentPairsReducer';
import { addAttachmentSelectedIdsReducer } from './addAttachmentSelectedIdsReducer';
import { getFilteredAttachmentsSuccessReducer } from './getFilteredAttachmentsSuccessReducer';
export const attachmentRootReducer = (state = createAttachmentState(), action) => {
    switch (action.type) {
        case ATTACHMENT_ADD_ATTACHMENTS: {
            return {
                byId: addAttachmentsReducer(state.byId, action),
                allIds: addAttachmentIdsReducer(state.allIds, action),
                attachmentPairs: action.payload.attachmentPairs,
                selectedIds: addAttachmentSelectedIdsReducer(state.selectedIds, action)
            };
        }
        case ATTACHMENT_GET_FILTERED_ATTACHMENTS_SUCCESS: {
            return getFilteredAttachmentsSuccessReducer(state, action);
        }
        case ATTACHMENT_UPDATE_ATTACHMENTS: {
            return Object.assign(Object.assign({}, state), { byId: updateAttachmentsReducer(state.byId, action) });
        }
        case ATTACHMENT_DELETE_ATTACHMENTS_SUCCESS: {
            return {
                byId: deleteAttachmentsReducer(state.byId, action),
                allIds: deleteAttachmentIdsReducer(state.allIds, action),
                attachmentPairs: deleteAttachmentPairsReducer(state.attachmentPairs, action),
                selectedIds: new Set()
            };
        }
        case ATTACHMENT_RESET_ATTACHMENTS:
            return createAttachmentState();
        case ATTACHMENT_SELECT_ATTACHMENT:
            return Object.assign(Object.assign({}, state), { selectedIds: selectAttachmentReducer(state.selectedIds, action) });
        case ATTACHMENT_CLEAR_ALL_ATTACHMENT_SELECTIONS:
            return Object.assign(Object.assign({}, state), { selectedIds: new Set() });
        default:
            return state;
    }
};
//# sourceMappingURL=attachmentRootReducer.js.map